// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyDKqJhOAWCbKIVGV7GrSk3x1hJwu2OryMc",
  authDomain: "auth.supa.place",
  databaseURL: "https://studio-282433670-dd879-default-rtdb.firebaseio.com",
  projectId: "studio-282433670-dd879",
  storageBucket: "studio-282433670-dd879.firebasestorage.app",
  messagingSenderId: "1082988524097",
  appId: "1:1082988524097:web:21ebbf68d7ab51817accc0"
};
